import { useState } from 'react';
import type { GameModuleProps } from '../types/game';

export function MultipleChoiceModule({ module, onComplete }: GameModuleProps<'multiple-choice'>) {
  const [attempts, setAttempts] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [locked, setLocked] = useState(false);

  const choose = (index: number) => {
    if (locked) return;
    const nextAttempts = attempts + 1;
    setAttempts(nextAttempts);
    if (index === module.config.correctIndex) {
      setLocked(true);
      setFeedback(module.config.successMessage || '¡Respuesta correcta!');
      window.setTimeout(() => onComplete({ success: true, attempts: nextAttempts }), 650);
    } else {
      setFeedback('Casi. Probá otra vez ✨');
    }
  };

  return (
    <div className="module-content">
      <p className="question">{module.config.question}</p>
      <div className="choice-grid">
        {module.config.options.map((option, index) => (
          <button className="choice" disabled={locked} key={option} onClick={() => choose(index)}>{option}</button>
        ))}
      </div>
      <p className="feedback" aria-live="polite">{feedback}</p>
      <p className="attempts">Intentos: {attempts}</p>
    </div>
  );
}

